<template>
  <a-card :bordered="false" style="height: 100%">
    <div v-if="isShowSearch" class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchByquery">
        <a-row :gutter="24" v-if="queryInfo && queryInfo.length>0">
          <template v-for="(item,index) in queryInfo">
            <template v-if="item.hidden === '1'">
              <a-col v-if="item.view === 'datetime' && 'single' !== item.mode" :md="12" :sm="16" :key=" 'query'+index " v-show="toggleSearchStatus">
                <online-query-form-item :queryParam="queryParam" :item="item" :dictOptions="dictOptions" />
              </a-col>
              <!-- 多级联动组件渲染 -->
              <mtcLinkDown v-else-if="item.view === 'link_down'"
                           @changeQuery="changeQuery"
                           :queryParam="queryParam"
                           :formitem="item"
                           v-show="toggleSearchStatus" />
              <a-col v-else :md="6" :sm="8" :key=" 'query'+index " v-show="toggleSearchStatus">
                <online-query-form-item :queryParam="queryParam" :item="item" :dictOptions="dictOptions" />
              </a-col>
            </template>
            <template v-else>
              <a-col v-if="item.view === 'datetime' && 'single'!== item.mode" :md="12" :sm="16" :key=" 'query'+index ">
                <online-query-form-item :queryParam="queryParam" :item="item" :dictOptions="dictOptions" />
              </a-col>
              <mtcLinkDown v-else-if="item.view === 'link_down'" :formitem="item" :queryParam="queryParam" />
              <a-col v-else :md="6" :sm="8" :key=" 'query'+index ">
                <online-query-form-item :queryParam="queryParam" :item="item" :dictOptions="dictOptions" />
              </a-col>
            </template>
          </template>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <mtc-button type="primary" @click="searchByquery" icon="search" text="button.search" />
              <mtc-button type="primary" @click="searchReset" icon="reload" text="button.reset" style="margin-left: 8px" />
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                <mtcLangPopover :text="toggleSearchStatus? 'tip.up': 'tip.down'" />
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" style="padding: 0 8px" />
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <slot name="toolsLeft"></slot>
    <!-- 操作按钮区域 -->
    <div v-if="isShowTools" class="table-operator">
      <!-- 新建 -->
      <mtc-button v-if="buttonSwitch.add" @click="handleAdd" type="primary" icon="plus" text="button.add" />
      <!-- 导入 -->
      <mtc-button v-if="buttonSwitch.import" @click="handleImportXls" type="primary" icon="upload" text="button.import" />
      <!-- 导出 -->
      <mtc-button v-if="buttonSwitch.export" :loading="exportLoading" @click="handleExportXls" type="primary" icon="download" text="button.export" />
      <!-- 自定义按钮 -->
      <template v-if="cgButtonList && cgButtonList.length">
        <template v-for="(item,index) in cgButtonList">
          <a-button v-if=" item.optType=='js' "
                    :key=" 'cgbtn'+index "
                    @click="customerButtonClick(item)"
                    type="primary"
                    :icon="item.buttonIcon">
            {{ item.buttonName }}
          </a-button>
          <a-button v-else-if=" item.optType=='import' "
                    :key=" 'cgbtn'+index "
                    @click="customerButtonClick(item)"
                    type="primary"
                    :icon="item.buttonIcon">
            {{ item.buttonName }}
          </a-button>
          <a-button v-else-if=" item.optType=='action' "
                    :key=" 'cgbtn'+index "
                    @click="cgButtonActionHandler(item.buttonCode)"
                    type="primary"
                    :icon="item.buttonIcon">
            {{ item.buttonName }}
          </a-button>
        </template>
      </template>
      <!-- 高级查询 -->
      <!-- <j-super-query
        v-if="buttonSwitch.super_query"
        ref="superQuery"
        :fieldList="superQuery.fieldList"
        :saveCode="$route.fullPath"
        :loading="table.loading"
        @handleSuperQuery="handleSuperQuery"/>-->
      <!-- 批量删除 -->
      <mtc-button v-if="buttonSwitch.batch_delete"
                  @click="handleDelBatch"
                  v-show="table.selectedRowKeys.length > 0"
                  ghost
                  type="danger"
                  text="button.batchDelete"
                  icon="delete" />
    </div>
    <!-- 列表区域 -->
    <div>
      <div v-if="isShowSearch" class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <span>
          <a-icon class="anticon ant-alert-icon" theme="filled" type="info-circle" />
          <!-- 已选择 -->
          <mtcLangPopover text="tip.selected" />：
          <!-- 条数 -->
          <a style="font-weight: 600">{{ table.selectedRowKeys.length }}</a>
          <!-- 单位 -->
          <mtcLangPopover text="tip.term" />
          <mtcLangPopover text="button.clear">
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
          </mtcLangPopover>
        </span>
        <span style="float:right;">
          <a-popover :overlayStyle="{maxWidth:'500px'}" trigger="click" placement="leftBottom" @visibleChange="popVisibleChange">
            <template #title>
              <!-- 自定义列 -->
              <mtcLangPopover text="systemBase.customColumn" />
            </template>
            <a><a-icon type="setting" /></a>
            <template slot="content">
              <a-checkbox-group v-model="settingColumns">
                <a-row>
                  <div v-for="(item,index) in defColumns">
                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                      <a-checkbox :value="item.dataIndex">
                        <mtcLangPopover :text="item.slotName" :defaultTitle="item.realTitle" />
                      </a-checkbox>
                    </template>
                  </div>
                </a-row>
              </a-checkbox-group>
            </template>
          </a-popover>
        </span>
      </div>
      <a-table ref="cgformAutoList"
               bordered
               size="middle"
               rowKey="id"
               :columns="tableColumn"
               :dataSource="table.dataSource"
               :pagination="table.pagination"
               :loading="table.loading"
               :rowSelection="rowSelectionConfig"
               @change="handleTableChange"
               :scroll="tableScroll"
               :class="{'j-table-force-nowrap': enableScrollBar}"
               style="min-height: 300px">
        <!-- 表头自定义渲染 -->
        <template v-for="(item, index) in tableColumn" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" :defaultTitle="item.realTitle" />
        </template>
        <!-- 列表数据自定义渲染 -->
        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in showDataLangCell">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
        <template slot="dateSlot" slot-scope="text">
          <span>{{ getFormatDate(text) }}</span>
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <mtcLangPopover v-if="!text" text="label.noPicture" style="font-size: 12px;font-style: italic;" />
          <img v-else
               :src="getImgView(text)"
               @click="imagePreview(getImgView(text))"
               height="25px" alt=""
               style="max-width:80px;font-size: 12px;font-style: italic;" />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <mtcLangPopover v-if="!text" text="label.noFile" style="font-size: 12px;font-style: italic;" />
          <mtc-button v-else
                      :ghost="true"
                      type="primary"
                      icon="download"
                      size="small"
                      text="button.clickToDownload"
                      @click="downloadRowFile(text)" />
        </template>
        <span slot="action" slot-scope="text, record">
          <template v-if="hasBpmStatus">
            <template v-if="record.bpm_status == '1'||record.bpm_status == ''|| record.bpm_status == null">
              <template v-if="buttonSwitch.update">
                <mtcLangPopover text="button.edit">
                  <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
                </mtcLangPopover>
              <a-divider type="vertical" />
            </template>
            </template>
          </template>
          <template v-else>
            <template v-if="buttonSwitch.update">
              <mtcLangPopover text="button.edit">
                <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
              </mtcLangPopover>
              <a-divider type="vertical" />
            </template>
          </template>
          <a-dropdown>
            <a class="ant-dropdown-link">
              <mtcLangPopover text="button.more" />
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="buttonSwitch.detail">
                <mtcLangPopover text="button.details">
                  <a href="javascript:;" @click="handleDetail(record)">{{ $t('button.details') }}</a>
                </mtcLangPopover>
              </a-menu-item>
              <template v-if="hasBpmStatus">
                <template v-if="record.bpm_status == '1'||record.bpm_status == ''|| record.bpm_status == null">
                    <a-menu-item v-if="buttonSwitch.bpm">
                      <a href="javascript:;" @click="startProcess(record)">提交流程</a>
                    </a-menu-item>
                    <a-menu-item v-if="buttonSwitch.delete">
                      <a-popconfirm :title="$t('tip.isDelete')" @confirm="handleDeleteOne(record)">
                        <a>{{ $t('button.delete') }}</a>
                      </a-popconfirm>
                    </a-menu-item>
                </template>
                <template v-else>
                    <a-menu-item @click="handlePreviewPic(record)">审批进度</a-menu-item>
                </template>
              </template>
              <template v-else>
                <a-menu-item v-if="buttonSwitch.delete">
                  <a-popconfirm @confirm="() => handleDeleteOne(record)">
                    <mtcLangPopover slot="title" text="tip.isDelete" />
                    <mtcLangPopover text="button.delete">
                      <a>{{ $t('button.delete') }}</a>
                    </mtcLangPopover>
                  </a-popconfirm>
                </a-menu-item>
               </template>
              <template v-if="cgButtonLinkList && cgButtonLinkList.length>0" v-for="(btnItem,btnIndex) in cgButtonLinkList">
                <a-menu-item :key=" 'cgbtnLink'+btnIndex " v-if="showLinkButton(btnItem,record)">
                  <a href="javascript:void(0);" @click="cgButtonLinkHandler(record,btnItem.buttonCode,btnItem.optType)">
                    <a-icon v-if="btnItem.buttonIcon" :type="btnItem.buttonIcon" />
                    {{ btnItem.buttonName }}
                  </a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- 自定义上传 -->
    <a-upload style="display: none"
              :name="uploadParams.name"
              :showUploadList="false"
              :multiple="uploadParams.multiple"
              :accept="uploadParams.accept"
              :headers="tokenHeader"
              :action="uploadParams.url"
              @change="handleImport">
      <a-button type="primary" id="importButton" icon="import">明细导入</a-button>
    </a-upload>
    <onl-cgform-auto-modal @success="handleFormSuccess" ref="modal" :code="code" @schema="handleGetSchema" />
    <j-import-modal ref="importModal" :url="getImportUrl()" @ok="importOk"></j-import-modal>
    <process-inst-pic-modal ref="processInstPicModal"></process-inst-pic-modal>
    <!-- 跳转Href的动态组件方式 -->
    <j-modal v-bind="hrefComponent.model" v-on="hrefComponent.on" dialogClass="jeecg-online-modal">
      <component ref="dynamicComp" :is="hrefComponent.is" v-bind="hrefComponent.params" />
    </j-modal>
    <!-- 弹框表单设计器区域 -->
    <auto-desform-data-full-screen ref="desformModal" @ok="handleFormSuccess" />
    <!-- 图片预览模态框 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-card>
</template>

<script>
import mtcLinkDown from '@comp/mtcModule/mtcLinkDown'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { HrefJump } from '@/mixins/OnlAutoListMixin'
import OnlCgformAutoModal from './OnlCgformAutoModal'
import { postAction, getAction, deleteAction, downFile, getFileAccessHttpUrl } from '@/api/manage'
import { cloneObject, filterObj } from '@/utils/util'
import OnlineQueryFormItem from '@/components/online/autoform/OnlineQueryFormItem.vue'
import ProcessInstPicModal from '@/components/bpm/ProcessInstPicModal'
import ButtonExpHandler from '@/components/online/autoform/model/ButtonExpHandler'
import { onlUtil } from '@/mixins/OnlineCommonUtil'
import lodash_object from 'lodash'
import Vue from 'vue'
import AutoDesformDataFullScreen from '@/views/modules/online/desform/auto/modules/AutoDesformDataFullScreen'
import { listByBizId } from '@api/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'

export default {
  name: 'OnlCgFormAutoList',
  mixins: [HrefJump, mixinDevice, onlUtil],
  components: {
    OnlCgformAutoModal,
    OnlineQueryFormItem,
    ProcessInstPicModal,
    AutoDesformDataFullScreen,
    mtcLinkDown
  },
  props: {
    // 在线表单id
    codeKey: {
      type: String,
      default: ''
    },
    // 查询条件
    searchParams: {
      type: Object,
      default: () => {
      }
    },
    // 是否展示查询条件
    isShowSearch: {
      type: Boolean,
      default: true
    },
    // 是否展示按钮行
    isShowTools: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 自定义上传组件参数
      uploadParams: {
        name: 'file',
        multiple: false,
        accept: '.xls,.xlsx',
        url: ''
      },
      tokenHeader: {
        'X-Access-Token': this.$ls.get(ACCESS_TOKEN),
        'tenant-id': this.$ls.get(TENANT_ID)
      },
      // 当前点击的自定义按钮信息
      buttonCode: {},
      previewVisible: false,
      previewImage: '',
      lodash: lodash_object,
      description: '在线报表功能测试页面',
      currentTableName: '',
      exportLoading: false,
      url: {
        getQueryInfo: '/online/cgform/api/getQueryInfo/',
        getColumns: '/online/cgform/api/getColumns/',
        getData: '/online/cgform/api/getData/',
        optPre: '/online/cgform/api/form/',
        exportXls: '/online/cgform/api/exportXls/',
        buttonAction: '/online/cgform/api/doButton',
        startProcess: '/act/process/extActProcess/startMutilProcess'
      },
      flowCodePre: 'onl_',
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      //dictOptions:{fieldName:[]}
      dictOptions: {},
      cgButtonLinkList: [],
      cgButtonList: [],
      queryInfo: [],
      // 查询参数，多个页面的查询参数用 code 作为键来区分
      queryParamsMap: {},
      toggleSearchStatus: true,
      table: {
        loading: true,
        scroll: { x: false },
        // 表头
        columns: [],
        //数据集
        dataSource: [],
        // 选择器
        selectedRowKeys: [],
        selectionRows: [],
        // 分页参数
        pagination: {}
      },
      metaPagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return `${range[ 0 ]}-${range[ 1 ]} ${this.$t('tip.total')}${total} ${this.$t('tip.article')}`
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      actionColumn: {
        title: this.$t('tableHeader.operation'),
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        // fixed:"right",
        align: 'center',
        width: 150
      },
      formTemplate: '99',
      EnhanceJS: '',
      hideColumns: [],
      buttonSwitch: {
        add: true,
        update: true,
        delete: true,
        batch_delete: true,
        import: true,
        export: true,
        detail: true,
        super_query: true,
        bpm: true
      },
      hasBpmStatus: false,
      checkboxFlag: false,
      // 高级查询
      superQuery: {
        // 字段列表
        fieldList: [],
        // 查询参数
        params: '',
        // 查询条件拼接方式 'and' or 'or'
        matchType: 'and'
      },
      scrollFlag: 0,
      settingColumns: [],
      defColumns: [],
      //接受URL参数
      acceptHrefParams: {},
      isDesForm: '',
      desFormCode: '',
      // 每个字段的扩展参数
      fieldExtendJson: []
    }
  },
  created() {
    this.getInitUtilEnhanceJs(this.initAutoList)
  },
  watch: {
    '$route'() {
      // 刷新参数放到这里去触发，就可以刷新相同界面了
      this.initAutoList()
      this.fieldExtendJson = []
      this.isorter = {
        column: 'create_time',
        order: 'desc'
      }
    }
  },
  computed: {
    ...mapGetters(['tableLangField', 'tableLangMap']),
    // 在线表单id
    code() {
      if (this.codeKey) return this.codeKey
      return this.$route.params.code
    },
    showDataLangCell() {
      return this.tableColumn.filter(ele => this.tableLangField.includes(ele.dataIndex))
    },
    rowSelectionConfig: function() {
      if (!this.checkboxFlag) {
        return null
      }
      return {
        // fixed:true,
        selectedRowKeys: this.table.selectedRowKeys,
        onChange: this.handleChangeInTableSelect
      }
    },
    queryParam: {
      get() {
        return this.queryParamsMap[ this.code ]
      },
      set(newVal) {
        this.$set(this.queryParamsMap, this.code, newVal)
      }
    },
    enableScrollBar() {
      return this.scrollFlag === 1 || this.isMobile()
    },
    tableScroll() {
      // 移动端模式下无论如何都开启横向滚动条
      if (this.enableScrollBar) {
        return undefined
      } else {
        return this.table.scroll
      }
    },
    tableColumn() {
      if (!this.settingColumns || this.settingColumns.length <= 0) {
        return this.defColumns
      } else {
        const cols = this.defColumns.filter(item => {
          if (item.key == 'rowIndex' || item.dataIndex == 'action') {
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        return cols
      }
    },
    localCode() {
      return 'onl_' + this.currentTableName
    }
  },
  methods: {
    moment,
    // 根据扩展参数得到列表查询接口排序参数
    listSortExtend() {
      if (!this.fieldExtendJson.length) return null
      let temp = this.fieldExtendJson.find(ele => ele.orderRule)
      if (!temp) return null
      return {
        column: temp.dataIndex,
        order: temp.orderRule
      }
    },
    // 多级联动查询条件改变时清空
    changeQuery(obj) {
      this.queryParam = {
        ...this.queryParam,
        ...obj
      }
    },
    // 自定义上传按钮文件上传
    handleImport(e) {
      let { file } = e
      if (file.status === 'done') {
        let res = file.response
        if (res.code !== 200) return this.$message.warning(res.message)
        this.cgButtonJsHandler(this.buttonCode, res.result)
        this.loadData(1)
        this.$message.success('操作成功')
      }
    },
    imagePreview(url) {
      this.previewImage = url
      this.previewVisible = true
    },
    hasBpmStatusFilter() {
      var columnObjs = this.defColumns
      let columns = []
      for (var item of columnObjs) {
        columns.push(item.dataIndex)
      }
      if (columns.includes('bpm_status') || columns.includes('BPM_STATUS')) {
        this.hasBpmStatus = true
      } else {
        this.hasBpmStatus = false
      }
    },
    startProcess: function(record) {
      var that = this
      this.$confirm({
        title: '提示',
        content: '确认提交流程吗?',
        onOk: function() {
          var param = {
            flowCode: that.flowCodePre + that.currentTableName,
            id: record.id,
            formUrl: 'modules/bpm/task/form/OnlineFormDetail',
            formUrlMobile: 'check/onlineForm/detail'
          }
          postAction(that.url.startProcess, param).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.loadData()
              that.onClearSelected()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    handlePreviewPic: function(record) {
      var flowCode = this.flowCodePre + this.currentTableName
      var dataId = record.id
      this.$refs.processInstPicModal.preview(flowCode, dataId)
      this.$refs.processInstPicModal.title = '流程图'
    },
    initQueryInfo() {
      getAction(`${this.url.getQueryInfo}${this.code}`).then((res) => {
        console.log('--onlineList-获取查询条件配置', res)
        this.table.loading = false
        if (res.success) {
          if (!res.result || !res.result.length) return
          this.queryInfo = res.result
          //查询条件form 默认值设置
          for (let item of res.result) {
            if (item.config === '1') {
              if (item.defValue && item.defValue.length > 0 && item.mode === 'single') {
                this.$set(this.queryParam, item.field, item.defValue)
              }
            }
          }
        } else {
          this.$message.warning(res.message)
        }
        this.loadData()
      })
    },
    initAutoList() {
      if (!this.code) {
        return false
      }
      // 清空高级查询条件
      this.superQuery.params = ''
      if (this.$refs.superQuery) {
        this.$refs.superQuery.handleReset()
      }

      if (!this.queryParam) {
        this.queryParam = {}
      }
      this.handleAcceptHrefParams()
      this.table.loading = true
      getAction(`${this.url.getColumns}${this.code}`).then((res) => {
        console.log('--onlineList-加载动态列>>', res)
        if (res.success) {
          if (res.result.checkboxFlag == 'Y') {
            this.checkboxFlag = true
          } else {
            this.checkboxFlag = false
          }
          if (res.result.paginationFlag == 'Y') {
            this.table.pagination = { ...this.metaPagination }
          } else {
            this.table.pagination = false
          }
          // href 跳转
          const fieldHrefSlotKeysMap = {}
          res.result.fieldHrefSlots.forEach(item => fieldHrefSlotKeysMap[ item.slotName ] = item)
          this.dictOptions = res.result.dictOptions
          this.formTemplate = res.result.formTemplate
          this.description = res.result.description
          this.currentTableName = res.result.currentTableName
          this.isDesForm = res.result.isDesForm
          this.desFormCode = res.result.desFormCode
          this.initCgButtonList(res.result.cgButtonList)
          this.initCgEnhanceJs(res.result.enhanceJs)
          this.initButtonSwitch(res.result.hideColumns)
          let arr = []
          res.result.columns.forEach(column => {
            Object.keys(column).map(key => {
              // 删掉空值的字段（不删除 空字符串('') 或 数字 0 ）
              if (column[ key ] == null) {
                delete column[ key ]
              }
            })
            // 处理列中的 href 跳转和 dict 字典，使两者可以兼容存在
            this.handleColumnHrefAndDict(column, fieldHrefSlotKeysMap)
            // 处理显示长度
            this.handleColumnShowLength(column)
            // 扩展参数配置
            if (column.fieldExtendJson) {
              let fieldExtendJson = JSON.parse(column.fieldExtendJson)
              this.fieldExtendJson.push({
                ...column,
                ...fieldExtendJson
              })
            }
            let slotName = `dynamic.${column.language_key}`
            arr.push({
              slotName,
              align: column.align,
              scopedSlots: { customRender: column.scopedSlots?.customRender || column.dataIndex, title: slotName },
              dataIndex: column.dataIndex,
              language_key: column.language_key,
              sorter: column.sorter,
              customRender: column.customRender,
              realTitle: column.title
            })
          })
          console.warn(this.fieldExtendJson, '扩展参数', res.result.columns)
          this.defColumns = arr.concat([this.actionColumn])
          this.settingColumnsHandler(res.result.columns)
          this.scrollFlag = res.result.scrollFlag
          this.hasBpmStatusFilter()
          this.initQueryInfo()
          //加载新路由，清空checkbox选中
          this.table.selectedRowKeys = []
        } else {
          this.$message.warning(res.message)
        }
      }).finally(e => this.table.loading = true)
    },
    loadData(arg) {
      if (this.table.pagination) {
        if (arg == 1) {
          this.table.pagination.current = 1
        }
        this.table.loading = true
        let params = this.getQueryParams()//查询条件
        console.log('--onlineList-查询条件-->', params)
        getAction(`${this.url.getData}${this.code}`, params).then((res) => {
          console.log('--onlineList-列表数据', res)
          if (res.success) {
            let result = res.result
            this.getDataLang(result.records)
            if (Number(result.total) > 0) {
              this.table.pagination.total = Number(result.total)
              this.table.dataSource = result.records
            } else {
              this.table.pagination.total = 0
              this.table.dataSource = []
              //this.$message.warning("查无数据")
            }
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          this.table.loading = false
        })
      } else {
        this.loadDataNoPage()
      }
    },
    // 获取列表数据多语言信息
    getDataLang(data) {
      let ids = data?.map(ele => ele.id)
      let bizIds = ids.toString()
      bizIds && listByBizId({ bizIds }).then(res => {
        const result = res.result
        if (!result || !result.length) return
        let langObj = {}
        result?.forEach(ele => {
          langObj[ `${ele.relBizId},${ele.relField}` ] = result.filter(k => k.relBizId === ele.relBizId && k.relField === ele.relField)
        })
        this.$store.commit('SET_TABLELANGLIST', langObj)
        // 当前主表列表中有数据多语言字段
        let fieldArr = this.tableLangField
        let dataList = []
        // 替换列表中展示的值为当前设置的主语言的值
        data?.forEach(item => {
          fieldArr.forEach(ele => {
            let newValue = this.getLangListById(item.id, ele)
            console.log(newValue, 'newValue：')
            if (newValue) item[ ele ] = newValue
          })
          dataList.push(item)
        })
        this.table.dataSource = dataList
      })
    },
    // 根据数据id和字段code获取多语言信息
    getLangListById(id, field) {
      let mainLang = this.$ls.get('language') || 'zh-cn'
      let langObj = this.tableLangMap
      if (!langObj[ `${id},${field}` ]) return ''
      return langObj[ `${id},${field}` ]?.find(lang => lang.langType === mainLang)?.langText || ''
    },
    loadDataNoPage() {
      this.table.loading = true
      let param = this.getQueryParams()//查询条件
      param[ 'pageSize' ] = -521
      getAction(`${this.url.getData}${this.code}`, filterObj(param)).then((res) => {
        console.log('--onlineList-列表数据', res)
        if (res.success) {
          let result = res.result
          if (Number(result.total) > 0) {
            this.table.dataSource = result.records
          } else {
            this.table.dataSource = []
          }
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.table.loading = false
      })
    },
    //接受URL参数
    handleAcceptHrefParams() {
      this.acceptHrefParams = {}
      let hrefparam = this.$route.query
      if (hrefparam) {
        this.acceptHrefParams = { ...hrefparam }
        Object.keys(hrefparam).map(key => {
          this.queryParam[ key ] = hrefparam[ key ]
        })
      }
    },
    getQueryParams() {
      // 如果有排序的扩展参数则覆盖原有的排序字段
      if (this.listSortExtend()) this.isorter = this.listSortExtend()
      let param = Object.assign({}, this.acceptHrefParams, this.queryParam, this.isorter)
      console.warn(this.listSortExtend(), '排序参数', param)
      param.pageNo = this.table.pagination.current
      param.pageSize = this.table.pagination.pageSize
      param.superQueryMatchType = this.superQuery.matchType
      param.superQueryParams = encodeURIComponent(this.superQuery.params)
      return filterObj({ ...param, ...this.searchParams })
    },
    handleChangeInTableSelect(selectedRowKeys, selectionRows) {
      this.table.selectedRowKeys = selectedRowKeys
      this.table.selectionRows = selectionRows
      this.selectedRowKeys = selectedRowKeys
    },
    handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order? 'asc': 'desc'
      }
      if (this.table.pagination) {
        this.table.pagination = pagination
      }
      this.loadData()
    },
    handleAdd() {
      if (this.isDesForm === 'Y') {
        this.$refs.desformModal.open('add', this.desFormCode, null, '新增数据')
      } else {
        this.cgButtonJsHandler('beforeAdd')
        this.$refs.modal.add(this.formTemplate)
      }
    },
    handleImportXls() {
      this.$refs.importModal.show()
    },
    importOk() {
      this.loadData(1)
    },
    handleExportXls2() {
      let param = this.queryParam
      if (this.table.selectedRowKeys && this.table.selectedRowKeys.length > 0) {
        param[ 'selections' ] = this.table.selectedRowKeys.join(',')
      }
      let paramsStr = encodeURI(JSON.stringify(param))
      console.log('paramsStr: ' + paramsStr)
      let url = window._CONFIG.domianURL + this.url.exportXls + this.code + '?paramsStr=' + paramsStr
      window.location.href = url
    },
    handleExportXls() {
      //update--begin--autor:lvdandan-----date:20201110------for：LOWCOD-998 导出参数添加高级查询
      let param = this.getQueryParams()
      //update--end--autor:lvdandan-----date:20201110------for：LOWCOD-998 导出参数添加高级查询
      if (this.table.selectedRowKeys && this.table.selectedRowKeys.length > 0) {
        param[ 'selections' ] = this.table.selectedRowKeys.join(',')
      }
      let paramsStr = JSON.stringify(filterObj(param))
      this.exportLoading = true
      downFile(this.url.exportXls + this.code, { paramsStr: paramsStr }).then((data) => {
        if (!data || data.size === 0) {
          this.$message.warning(this.$t('tip.fileDownloadFailed'))
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data]), this.description + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', this.description + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      }).finally(e => this.exportLoading = false)
    },
    handleEdit(record) {
      if (this.isDesForm === 'Y') {
        this.$refs.desformModal.open('edit', this.desFormCode, record.id, '编辑数据', true)
      } else {
        this.cgButtonLinkHandler(record, 'beforeEdit', 'js')
        this.$refs.modal.edit(this.formTemplate, record.id)
      }
    },
    showLinkButton(item, record) {
      let btn = new ButtonExpHandler(item.exp, record)
      return btn.show
    },
    handleDetail(record) {
      if (this.isDesForm === 'Y') {
        this.$refs.desformModal.open('detail', this.desFormCode, record.id, '查看数据', true)
      } else {
        this.$refs.modal.detail(this.formTemplate, record.id)
      }
    },
    handleDeleteOne(record) {
      this.cgButtonLinkHandler(record, 'beforeDelete', 'js')
      this.handleDelete(record.id)
    },
    handleDelete(id) {
      deleteAction(this.url.optPre + this.code + '/' + id).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleFormSuccess() {
      this.loadData()
    },
    // 查询完 schema 后，生成高级查询的字段列表
    handleGetSchema(schema) {
      if (schema && schema.properties) {
        let setField = (array, field) => {
          let type = field.view || (field.type || 'string')
          type = (type === 'inputNumber'? 'number': type)
          let params = {
            type: type,
            value: field.key,
            text: field.title,
            // 额外字典参数
            dictCode: field.dictCode,
            dictTable: field.dictTable,
            dictText: field.dictText,
            options: field.enum || field.options,
            order: field.order
          }
          // 处理popup
          if (type === 'popup') {
            params[ 'popup' ] = {
              code: field.popupCode || field.code,
              field: field.orgFields.split(',')[ 0 ],
              orgFields: field.orgFields.split(',')[ 0 ],
              destFields: field.destFields.split(',')[ 0 ]
            }
          }
          array.push(params)
        }
        let fieldList = []
        for (let key in schema.properties) {
          if (!schema.properties.hasOwnProperty(key)) {
            continue
          }
          let field = schema.properties[ key ]
          // tab = 子表 一对多
          if (field.view === 'tab' && field.relationType == 0) {
            let subTable = {
              type: 'sub-table',
              value: field.key,
              text: field.describe,
              children: []
            }
            if (field.columns) {
              for (let column of field.columns) {
                setField(subTable.children, column)
              }
            }
            fieldList.push(subTable)
            // tab = 子表 一对一
          } else if (field.view === 'tab' && field.relationType == 1) {
            let subTable = {
              type: 'sub-table',
              value: field.key,
              text: field.describe,
              children: []
            }
            Object.keys(field.properties).map(k => {
              field.properties[ k ][ 'key' ] = k
              setField(subTable.children, field.properties[ k ])
            })
            fieldList.push(subTable)
          } else {
            field.key = key
            setField(fieldList, field)
          }
        }
        // 冒泡排序
        for (let i = 0; i < fieldList.length; i++) {
          for (let j = i + 1; j < fieldList.length; j++) {
            let temp1 = fieldList[ i ]
            let temp2 = fieldList[ j ]
            if (temp1.order > temp2.order) {
              fieldList[ i ] = temp2
              fieldList[ j ] = temp1
            }
          }
        }
        this.superQuery.fieldList = fieldList
      }
    },
    onClearSelected() {
      this.table.selectedRowKeys = []
      this.table.selectionRows = []
    },
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      return getFileAccessHttpUrl(text)
    },
    downloadRowFile(text) {
      if (!text) return this.$message.warning('未知的文件')
      if (text.indexOf(',') !== -1) {
        let arr = text.split(',')
        arr.forEach(ele => {
          window.open(ele)
        })
      }else {
        let url = getFileAccessHttpUrl(text)
        window.open(url)
      }
    },
    handleDelBatch() {
      if (this.table.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      } else {
        let ids = ''
        let that = this
        that.table.selectedRowKeys.forEach(function(val) {
          ids += val + ','
        })
        that.$confirm({
          title: this.$t('tip.confirmDeletion'),
          content: this.$t('tip.deleteTheSelectedData'),
          onOk() {
            that.handleDelete(ids)
            that.onClearSelected()
          }
        })
      }
    },
    searchByquery() {
      this.loadData(1)
    },
    searchReset() {
      this.queryParam = {}
      debugger
      let path = this.$route.path; //先获取路由路径
      // this.$router.push({ query: {} });
      // this.$store.dispatch('delVisitedViews', this.$route);
      // this.$parent.closeRouteViewTab(this.$route.path)
      // this.$router.push(path); //再跳转路由路径，query参数没带过去，所以被清除了
      // location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
      this.acceptHrefParams={}
      this.loadData(1)
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    getFormatDate(text) {
      if (!text) {
        return ''
      }
      let a = text
      if (a.length > 10) {
        a = a.substring(0, 10)
      }
      return a
    },
    getImportUrl() {
      return '/online/cgform/api/importXls/' + this.code
    },
    // 初始化JS增强方法
    initCgEnhanceJs(enhanceJs) {
      //console.log("--onlineList-js增强",enhanceJs)
      if (enhanceJs) {
        let Obj = eval('(' + enhanceJs + ')')
        /*
        * function OnlineEnhanceJs(getAction, postAction, deleteAction) {
            return {
              _getAction: getAction,
              _postAction: postAction,
              _deleteAction: deleteAction,
              created: function(that) {
                const getAction = this._getAction, postAction = this._postAction, deleteAction = this._deleteAction
                console.log(2)
              }
            }
          }
        *
        * */
        this.EnhanceJS = new Obj(getAction, postAction, deleteAction)
        // 初始化JS增强中的created方法
        this.cgButtonJsHandler('created')
      } else {
        this.EnhanceJS = ''
      }
    },
    initCgButtonList(btnList) {
      let linkArr = []
      let buttonArr = []
      if (btnList && btnList.length > 0) {
        for (let i = 0; i < btnList.length; i++) {
          let temp = btnList[ i ]
          if (temp.buttonStyle == 'button') {
            buttonArr.push(temp)
          } else if (temp.buttonStyle == 'link') {
            linkArr.push(temp)
          }
        }
      }
      this.cgButtonLinkList = [...linkArr]
      this.cgButtonList = [...buttonArr]
    },
    // 执行JS增强里的方法
    cgButtonJsHandler(buttonCode, data) {
      if (this.EnhanceJS[ buttonCode ]) return this.EnhanceJS[ buttonCode ](this, data)
    },
    // 自定义按钮事件
    customerButtonClick(buttonItem) {
      this.buttonCode = buttonItem
      let code = buttonItem.buttonCode
      if (this.EnhanceJS[ code ]) {
        if (buttonItem.optType === 'import') return this.initImport(code)
        this.EnhanceJS[ code ](this)
      }
    },
    // 初始化自定义上传按钮的上传参数
    initImport(buttonCode) {
      let importParams = this.cgButtonJsHandler(buttonCode)
      if (!importParams) return this.$message.warning('请设置上传参数')
      importParams.url = window._CONFIG.domianURL + importParams.url
      this.uploadParams = Object.assign(this.uploadParams, importParams)
      let dom = document.getElementById('importButton')
      dom.click()
    },
    cgButtonActionHandler(buttonCode) {
      //处理自定义button的 需要配置该button自定义sql
      if (!this.table.selectedRowKeys || this.table.selectedRowKeys.length == 0) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      if (this.table.selectedRowKeys.length > 1) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      let params = {
        formId: this.code,
        buttonCode: buttonCode,
        dataId: this.table.selectedRowKeys[ 0 ]
      }
      console.log('自定义按钮请求后台参数：', params)
      postAction(this.url.buttonAction, params).then(res => {
        if (res.success) {
          this.loadData()
          this.$message.success(res.message)
        } else {
          this.$message.warning(res.message)
        }
      })

    },
    cgButtonLinkHandler(record, buttonCode, optType) {
      if (optType == 'js') {
        if (this.EnhanceJS[ buttonCode ]) {
          this.EnhanceJS[ buttonCode ](this, record)
        }
      } else if (optType == 'action') {
        let params = {
          formId: this.code,
          buttonCode: buttonCode,
          dataId: record.id
        }
        console.log('自定义按钮link请求后台参数：', params)
        postAction(this.url.buttonAction, params).then(res => {
          if (res.success) {
            this.loadData()
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    },
    initButtonSwitch(hideColumns) {
      Object.keys(this.buttonSwitch).forEach(key => {
        this.buttonSwitch[ key ] = true
      })
      if (hideColumns && hideColumns.length > 0) {
        Object.keys(this.buttonSwitch).forEach(key => {
          if (hideColumns.indexOf(key) >= 0) {
            this.buttonSwitch[ key ] = false
          }
        })
      }
    },
    // 高级查询
    handleSuperQuery(params, matchType) {
      if (!params || params.length === 0) {
        this.superQuery.params = ''
      } else {
        this.superQuery.params = JSON.stringify(params)
      }
      this.superQuery.matchType = matchType
      this.loadData(1)
    },
    settingColumnsHandler(columns) {
      let str = Vue.ls.get(this.localCode)
      if (!str || str.length == 0) {
        this.settingColumns = []
        columns.forEach(column => {
          if (this.settingColumns.indexOf(column[ 'dataIndex' ]) < 0) {
            this.settingColumns.push(column[ 'dataIndex' ])
          }
        })
      } else {
        this.settingColumns = str.split(',')
      }
    },
    popVisibleChange(visible) {
      if (this.settingColumns && this.settingColumns.length > 0) {
        Vue.ls.set(this.localCode, this.settingColumns.join(','))
      }
    }
  }
}
</script>

<style scoped>

.ant-card-body .table-operator {
  margin-bottom: 8px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px
}

.ant-btn-danger {
  background-color: #ffffff
}

.anty-img-wrap {
  height: 25px;
  position: relative;
}

.anty-img-wrap > img {
  max-height: 100%;
}

.ant-modal-cust-warp {
  height: 100%
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden
}
</style>